export const typeInfo = Object.freeze({
  analysis: {
    text: "지문분석",
    color: "#2DF034",
    backgroundColor: "rgba(45, 240, 52, 0.15)",
    answerTextColor: "white",
    badgeColor: "rgba(45, 240, 52, 0.45)",
  },
  comprehensive: {
    text: "내용이해",
    color: "#FFAA34",
    backgroundColor: "rgba(255, 170, 52, 0.15)",
    answerTextColor: "white",
    badgeColor: "rgba(255, 170, 52, 0.6)",
  },
  paragraph: {
    text: "모의고사",
    color: "#11346A",
    backgroundColor: "rgba(67, 140, 251, 0.05)",
    answerTextColor: "white",
    badgeColor: "rgba(67, 140, 251, 0.35)",
  },
  vocabulary: {
    text: "단어테스트",
    color: "#11346A",
    backgroundColor: "rgba(67, 140, 251, 0.05)",
    answerTextColor: "white",
    badgeColor: "rgba(255, 86, 187, 0.35)",
  },
  paper_assignment: {
    text: "지필과제",
    color: "#28a745",
    backgroundColor: "rgba(40, 167, 69, 0.05)",
    answerTextColor: "white",
    badgeColor: "rgba(40, 167, 69, 0.6)",
  },
  class_content: {
    text: "수업결과",
    color: "#6f42c1",
    backgroundColor: "rgba(111, 66, 193, 0.05)",
    answerTextColor: "white",
    badgeColor: "rgba(111, 66, 193, 0.6)",
  },
});
